<template>
    <div>
        <DataTable :value="bookTypes" lazy paginator dataKey="id"
                   v-model:rows="searchCriteria.page.limit" v-model:first="searchCriteria.page.offset" removableSort
                   :totalRecords="totalRecords" :loading="loading" @page="onPage"
                   @sort="onPage" :rowsPerPageOptions="[5,10,20,50]"
                   selection-mode="single" v-model:selection="selectedTableElement" @row-click="onRowSelect"
                   filterDisplay="row" v-model:filters="searchCriteria" @update:filters="search" scrollable
                   scrollHeight="calc(100vh - 300px)">
            <Column field="code" :header="$t('message.studbookType.code')" :sortable="true"
                    filterField="code" :showFilterMenu="false"
                    :showClearButton="false" class="w-2">
                <template #body="{ data }">
                    {{ data.code }}
                </template>
                <template #filter>
                    <CustomInputText name="code" v-model="searchCriteria.code" class="mb-0"
                                     @update:modelValue="search"/>
                </template>
            </Column>
            <Column field="authority" :header="$t('message.studbookType.authority')" :sortable="true" filterField="authority"
                    :showFilterMenu="false" :showClearButton="false" class="w-3">
                <template #body="{ data }">
                    {{ data.authority }}
                </template>
                <template #filter>
                    <CustomInputText name="authority" v-model="searchCriteria.authority" class="mb-0"
                                     @update:modelValue="search"/>
                </template>
            </Column>
            <Column field="country.name" :header="$t('message.studbookType.country')" :sortable="true" filterField="country"
                    :showFilterMenu="false" :showClearButton="false" class="w-3" sortField="country.name">
                <template #body="{ data }">
                    {{ data.country?.name }}
                </template>
                <template #filter>
                    <CustomSelectOne name="country" v-model="searchCriteria.name" class="mb-0"
                                     @update:modelValue="search" :items="countries" itemLabel="name" itemValue="name"/>
                </template>
            </Column>
            <Column field="country" :header="$t('message.studbookType.countryCode')" :filterField="computedFilterField()"
                    :showFilterMenu="false" :showClearButton="false" class="w-3">
                <template #body="{ data }">
                    {{ horseBreed === "ARABIAN" ? data.country?.alpha2 : data.country?.alpha3 }}
                </template>
                <template #filter>
                    <CustomSelectOne v-if="horseBreed === 'ARABIAN'" name="alpha2" v-model="searchCriteria.alpha2" class="mb-0"
                                     @update:modelValue="search" :items="countries" itemLabel="alpha2" itemValue="alpha2"/>
                    <CustomSelectOne v-else name="alpha3" v-model="searchCriteria.alpha3" class="mb-0"
                                     @update:modelValue="search" :items="countries" itemLabel="alpha3" itemValue="alpha3"/>
                </template>
            </Column>
            <template #empty>
                {{ $t('message.other.emptyTable') }}
            </template>
        </DataTable>
    </div>
</template>

<script>
import Button from "primevue/button";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { searchBookType, searchBookTypeCount } from "@/swagger/vue-api-client";
import CustomInputText from "@/components/form/CustomInputText.vue";
import { ScrollToUtils } from "@/utils/ScrollToUtils";
import CustomSelectOne from "@/components/form/inner/CustomSelectOne.vue";

export default {
    name: "BookTypeTable",
    components: {
        CustomInputText,
        Button,
        Column,
        DataTable,
        CustomSelectOne,
    },

    props: {
        modelValue: null,
        countries: {
            type: Array,
            default: () => [],
        },
        horseBreed: null,
    },

    emits: ["update:modelValue", "showForm"],

    data() {
        return {
            loading: false,
            totalRecords: 0,
            bookTypes: [],
            searchCriteria: this.getClearSearchCriteria(),
            selectedTableElement: null,
        };
    },

    mounted() {
        this.onPage(this.getFirstPage());
    },

    methods: {
        search() {
            this.onPage(this.getFirstPage());
        },

        prepareCriteria() {
            if (!this.searchCriteria.name) {
                this.searchCriteria.name = "";
            }
            if (!this.searchCriteria.alpha2) {
                this.searchCriteria.alpha2 = "";
            }
            if (!this.searchCriteria.alpha3) {
                this.searchCriteria.alpha3 = "";
            }

            const criteria = {...this.searchCriteria};

            return criteria;
        },

        onPage(event) {
            this.loading = true;
            this.searchCriteria.page.offset = event.first;
            this.searchCriteria.page.limit = event.rows;
            this.searchCriteria.page.sortField = event.sortField;
            this.searchCriteria.page.sortOrder = event.sortOrder;

            const criteria = this.prepareCriteria();

            searchBookType({ body: criteria }).then((response) => {
                this.bookTypes = response.data;
                return searchBookTypeCount({ body: criteria })
                    .then((response) => {
                        this.totalRecords = response.data;
                        this.loading = false;
                    });
            });
        },

        getFirstPage() {
            return {
                first: this.searchCriteria.page.offset,
                rows: this.searchCriteria.page.limit,
            };
        },

        onRowSelect(event) {
            ScrollToUtils.scrollToElement();
            this.$emit("showForm");
            this.selectedBookType = event.data;
        },

        getClearSearchCriteria() {
            return {
                code: "",
                authority: "",
                name: "",
                alpha2: "",
                alpha3: "",
                page: {
                    limit: 10,
                    offset: 0,
                    sortField: null,
                    sortOrder: null,
                },
            };
        },

        addNewBook() {
            this.selectedTableElement = null;
        },

        reloadTable() {
            this.search();
        },

        computedSortField() {
            if (this.horseBreed === "ARABIAN") return "country.aplha2";
            return "country.aplha3";
        },
        computedFilterField() {
            if (this.horseBreed === "ARABIAN") return "aplha2";
            return "aplha3";
        },
    },

    computed: {
        selectedBookType: {
            get() { return this.modelValue; },
            set(value) { this.$emit("update:modelValue", value); },
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
